import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';

const SvgComponent = (props: SvgProps) => (
  <Svg width={24} height={24} fill="none" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.026 9.802a.947.947 0 0 0-.804-.686l-5.072-.493-2.005-5.017a.935.935 0 0 0-.86-.606.934.934 0 0 0-.858.607L9.422 8.623l-5.073.493a.95.95 0 0 0-.803.686c-.116.38-.009.798.273 1.06l3.834 3.594-1.13 5.323c-.084.391.059.796.362 1.03.164.127.355.191.547.191.166 0 .331-.048.48-.142l4.374-2.795 4.373 2.795a.881.881 0 0 0 1.026-.048c.304-.236.446-.64.364-1.031l-1.13-5.323 3.833-3.593c.282-.263.39-.68.274-1.061Z"
      fill={props.color}
    />
  </Svg>
);

const StartIcon = memo(SvgComponent);
export default StartIcon;
